export default function (value) {
	let capStr = '';
	if (value) {
		capStr = value.charAt(0) + value.slice(1).toLowerCase();
	}
	return capStr;
}
